module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-50.417724e5.JPG";